import type {
  SwitchboardsQueryVariables,
  Switchboards_Bool_Exp
} from "gql/api";
import { Order_By } from "gql/api";

export function restoreSwitchboards(arr: Array<string>): Switchboards_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export function deleteSwitchboards(arr: Array<string>): Switchboards_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export const defaultSwitchboardVars: SwitchboardsQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { enclosure: Order_By.Asc }
  ]
};

export const adminSwitchboardVars: SwitchboardsQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { enclosure: Order_By.Asc }
  ]
};

export const kocSwitchboardVars: SwitchboardsQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { enclosure: Order_By.Asc }
  ],
  where: {
    _or: [
      { include_koc_timestamp: { _is_null: false } },
      { only_koc_timestamp: { _is_null: false } }
    ]
  }
};
export const ecopetrolSwitchboardVars: SwitchboardsQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { enclosure: Order_By.Asc }
  ],
  where: {
    _or: [
      { include_ecopetrol_timestamp: { _is_null: false } },
      { only_ecopetrol_timestamp: { _is_null: false } }
    ]
  }
};
